export default "__VITE_ASSET__QW_2UUxK__"